import { markdownToHtml, jsonBlocksToMarkdown } from './docMarkdown';

// Convertidor de contenido `DocContent.content` (el modelo clásico: string HTML/markdown con
// tokens `::(mention(...))` / `::(image(...))` / `::(pagelink(...))` y divs marcadores de
// bloque) → HTML parseable por Tiptap + las extensiones de `features/docs/components/extensions`.
// Integración main→dev, epic D2 (Opción A, sub-plan D2 §2 punto 1 / §10 D2.4b).
//
// Estrategia: lazy-on-load con guard anti-escritura (el editor NO autoguarda hasta la primera
// edición real del usuario), así abrir un doc viejo nunca reescribe su contenido. Ver
// `DocsCollaborativeEditor`.

// Los 3 marcadores que Tiptap no sabe montar como widget vivo bajo Opción A
// (`DatabaseExtension` es un placeholder; inline-flow / inline-ops-table no tienen extensión).
// Se normalizan a un placeholder genérico que conserva los `data-*` — sin pérdida de datos,
// solo sin render vivo (se recupera en D2.5).
const PLACEHOLDER_BLOCKS = [
    { cls: 'doc-inlineflow-block', label: 'Diagrama de flujo' },
    { cls: 'doc-inline-ops-table-block', label: 'Tabla de operaciones' },
];

function normalizePlaceholderBlocks(html) {
    if (typeof html !== 'string' || !html.includes('doc-')) return html;
    let out = html;
    for (const { cls, label } of PLACEHOLDER_BLOCKS) {
        // <div class="doc-...-block" data-id="..." ...>...</div>  →  placeholder que la
        // `EmbedPlaceholderExtension` monta por clase.
        const re = new RegExp(`<div([^>]*class="[^"]*${cls}[^"]*"[^>]*)>[\\s\\S]*?<\\/div>`, 'gi');
        out = out.replace(re, (_m, attrs) => `<div${attrs} data-embed-label="${label}"><div class="body">${label} (se restaura en D2.5)</div></div>`);
    }
    return out;
}

export function docToTiptapHtml(content, { docId } = {}) {
    if (!content) return '';

    let raw = content && typeof content === 'object' && 'content' in content ? content.content : content;
    if (typeof raw !== 'string') {
        raw = jsonBlocksToMarkdown(content || '');
    }

    // Tokens markdown heredados → HTML.
    if (typeof raw === 'string' && raw.includes('::(')) {
        raw = markdownToHtml(raw);
    }

    // Outline social huérfano guardado como texto.
    if (typeof raw === 'string' && raw.includes('Cargando outline...')) {
        raw = raw.replace(/<p>\s*Cargando outline\.\.\.\s*<\/p>/g, () => {
            const autoId = `social-outline-${docId || Date.now()}`;
            return `<div class="doc-inline-social-outline-block" data-id="${autoId}" contenteditable="false"><div class="body">Cargando outline...</div></div>`;
        });
    }

    raw = normalizePlaceholderBlocks(raw);

    if (typeof raw === 'string' && raw.trim().startsWith('<')) return raw;
    return markdownToHtml(raw || '');
}
